type PreloadLCPImageProps = { imageSource: string };

export default function PreloadLCPImage({
  imageSource,
}: PreloadLCPImageProps): React.ReactElement {
  return (
    <>
      <link rel="preload" as="image" href={imageSource} />
    </>
  );
}
